import { OrderLineFragment } from "@dashboard/graphql";

export const toLineWithUnfulfilledQuantity = (lines: OrderLineFragment[]) =>
  lines.map(({ quantityToFulfill, ...rest }) => ({
    ...rest,
    quantityToFulfill,
    // 'OrderLineFragment.quantity' is the total ordered quantity
    // When order is unfulfilled, we should show the remaining quantity to fulfill as the quantity.
    quantity: quantityToFulfill,
  }));

// Superusers can edit the not-yet-fulfilled part of placed orders. The editable
// grid shows that remaining quantity (and its total), while the API expects
// the line's total ordered quantity, so edits are mapped back with this.
export const toEditableUnfulfilledLine = (line: OrderLineFragment): OrderLineFragment => ({
  ...line,
  quantity: line.quantityToFulfill,
  totalPrice: {
    ...line.totalPrice,
    gross: {
      ...line.totalPrice.gross,
      amount: line.unitPrice.gross.amount * line.quantityToFulfill,
    },
    net: {
      ...line.totalPrice.net,
      amount: line.unitPrice.net.amount * line.quantityToFulfill,
    },
  },
});

export const getLineQuantityForUnfulfilledQuantity = (
  line: Pick<OrderLineFragment, "quantity" | "quantityToFulfill">,
  unfulfilledQuantity: number,
) => line.quantity - line.quantityToFulfill + unfulfilledQuantity;
